// src/components/filter.
import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { Link, useNavigate } from "react-router-dom";
import ReactDragListView from "react-drag-listview/lib/index.js";

import { Table, Col, Row, UncontrolledTooltip } from "reactstrap";
import { IoIosAdd } from "react-icons/io";
import { GrDrag } from "react-icons/gr";

//import components
import Breadcrumbs from "components/_Common/Breadcrumb";
import DeleteModal from "components/_Common/DeleteModal";
import { useDispatch, useSelector } from "react-redux";

// actions
import { listGlobalNorms } from "store/actions";
import AddEditModal from "../AddEdit/MailSendModel";
import toastr from "toastr";
import MyPagination from "components/_Common/MyPagination";
import { withTranslation } from "react-i18next";
import { onGenerateGlobalNorms } from "helpers/backend_api_helper";
import moment from "moment";

const List = (props) => {
  //meta title
  document.title = `${props.t("Norms")}  | ${props.t("Admin")}`;

  const { error, success, loading } = useSelector((state) => ({
    loading: state.Norms.loading,
    error: state.Norms.error,
    success: state.Norms.success,
  }));

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [modal, setModal] = useState(false);
  const [itemData, SetItemData] = useState();
  const [tableData, SetTableData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [filterData, setFilterData] = useState({
    limit: 25,
    page: currentPage,
    search: "",
  });

  const toggle = () => {
    if (modal) {
      setModal(false);
    } else {
      setModal(true);
    }
  };

  // list
  const fetchGlobalNormList = (filterData) => {
    dispatch(
      listGlobalNorms(filterData, (res) => {
        if (res?.status === "success") {
          SetTableData(res);
          SetItemData({});
        }
      })
    );
  };
  useEffect(() => {
    fetchGlobalNormList(filterData);
  }, []);

  const [loadingNorms, setLoadingNorms] = useState(false);
  const generateGlobalNorms = async (id, type) => {
    setLoadingNorms(true);
    try {
      const res = await onGenerateGlobalNorms(id, type);
      if (res?.status == "success") {
        toastr.success(res?.message);
        setLoadingNorms(false);
        fetchGlobalNormList();
      } else {
        toastr.error(res?.message || "Server Error");
        setLoadingNorms(false);
      }
    } catch (error) {
      setLoadingNorms(false);
    }
  };
  console.log(tableData?.data);
  return (
    <React.Fragment>
      <AddEditModal
        modal={modal}
        toggle={toggle}
        itemData={itemData}
        fetchGlobalNormListData={() => fetchGlobalNormList(filterData)}
      />
      <div className="page-content">
        <div className="container-fluid">
          <Breadcrumbs
            title={props.t("Norms")}
            breadcrumbItem={props.t("Global Norms")}
          />

          <Row>
            <Col lg="12">
              <Row className="mb-2 d-flex show-select show-select justify-spacebetween">
                {/* <Col md={1} className="me-4 space-marg-rem" >
                                     <select
                                        className="form-select custm-select"
                                        onChange={(e) => handleLimit(e.target.value)}
                                    >
                                        <option value="25">
                                            {props.t("Show")} 25
                                        </option>
                                        <option value="50">
                                            {props.t("Show")} 50
                                        </option>
                                        <option value="75">
                                            {props.t("Show")} 75
                                        </option>
                                        <option value="100">
                                            {props.t("Show")} 100
                                        </option>
                                    </select>
                                </Col> */}
                <Col md={4}></Col>

                <Col
                  md={4}
                  className="text-end pe-0 main-norms-btns-top custm-btns"
                >
                  {loadingNorms ? (
                    <button className="btn btn-primary">
                      {props.t("...Generate Global Norms")}
                    </button>
                  ) : (
                    <button
                      onClick={() => {
                        generateGlobalNorms();
                      }}
                      className="btn btn-primary"
                    >
                      {props.t("Generate Global Norms")}
                    </button>
                  )}
                </Col>
              </Row>
              <div className="main-norms-list">
                {loading ? (
                  <div className="loader d-flex justify-content-center align-items-center">
                    <i className="bx bx-loader bx-spin font-size-16 align-middle me-2"></i>{" "}
                    {props.t("Loading")}
                  </div>
                ) : (
                  <Row>
                    {tableData?.data && Array.isArray(tableData?.data) && (
                      <h3>
                        Generated On:{" "}
                        {moment(tableData[0]?.item?.created_at).format(
                          "DD/MM/YYYY"
                        )}
                      </h3>
                    )}

                    {(tableData?.data && Array.isArray(tableData?.data)
                      ? tableData?.data
                      : []
                    )?.map((item, index) => (
                      <Col md={6} key={index} className="inner-norms-list-col">
                        <div className="inner-norms-list">
                          <div className="d-flex">
                            <span
                              style={{
                                marginRight: "5px",
                                fontWeight: "bold",
                                fontSize: "15px",
                              }}
                            >
                              Q. {index + 1}
                            </span>{" "}
                            <span
                              dangerouslySetInnerHTML={{
                                __html: item?.aspiration_text,
                              }}
                            ></span>
                          </div>
                          <Table className="table mb-0 table-space">
                            <thead>
                              <tr>
                                <th>Raters</th>
                                <th> {props.t("SCHO")}</th>
                                <th> {props.t("R")}</th>
                              </tr>
                            </thead>

                            <tbody>
                              <tr>
                                <td>
                                  <b>Boss</b>
                                </td>
                                <td>
                                  {parseFloat(item?.scho_boss).toFixed(2)}
                                </td>
                                <td>{parseFloat(item?.r_boss).toFixed(2)}</td>
                              </tr>
                              <tr>
                                <td>
                                  <b>Superior</b>
                                </td>
                                <td>
                                  {parseFloat(item?.scho_superior).toFixed(2)}
                                </td>
                                <td>
                                  {parseFloat(item?.r_superior).toFixed(2)}
                                </td>
                              </tr>
                              <tr>
                                <td>
                                  <b>Peers</b>
                                </td>
                                <td>
                                  {parseFloat(item?.scho_peers).toFixed(2)}
                                </td>
                                <td>{parseFloat(item?.r_peers).toFixed(2)}</td>
                              </tr>
                              <tr>
                                <td>
                                  <b>Direct-Report</b>
                                </td>
                                <td>
                                  {parseFloat(item?.scho_direct_report).toFixed(
                                    2
                                  )}
                                </td>
                                <td>
                                  {parseFloat(item?.r_direct_report).toFixed(2)}
                                </td>
                              </tr>
                              <tr>
                                <td>
                                  <b>Other</b>
                                </td>
                                <td>
                                  {parseFloat(item?.scho_other).toFixed(2)}
                                </td>
                                <td>{parseFloat(item?.r_other).toFixed(2)}</td>
                              </tr>
                              <tr>
                                <td>
                                  <b>Self</b>
                                </td>
                                <td>
                                  {parseFloat(item?.scho_self).toFixed(2)}
                                </td>
                                <td>{parseFloat(item?.r_self).toFixed(2)}</td>
                              </tr>
                              <tr>
                                <td>
                                  <b>Overall</b>
                                </td>
                                <td>
                                  {parseFloat(item?.scho_overall).toFixed(2)}
                                </td>
                                <td>
                                  {parseFloat(item?.r_overall).toFixed(2)}
                                </td>
                              </tr>
                            </tbody>
                          </Table>
                        </div>
                      </Col>
                    ))}
                  </Row>
                )}
              </div>
              {/* {
                                tableData?.records < filterData?.limit ?
                                    ""
                                    :
                                    <MyPagination
                                        filterData={filterData}
                                        recordsPerPage={filterData?.limit}
                                        totalRecords={tableData?.records}
                                        currentPage={currentPage}
                                        onPageChange={(pageNumber) => {
                                            setCurrentPage(pageNumber)
                                            setFilterData(prevFilterData => ({
                                                ...prevFilterData,
                                                page: pageNumber
                                            }));
                                        }}
                                    />
                            } */}
            </Col>
          </Row>
        </div>
      </div>
    </React.Fragment>
  );
};

List.propTypes = {
  history: PropTypes.object,
  t: PropTypes.any,
};

export default withTranslation()(List);
